import React from "react";
import './index.less';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';

export default class FlyingVideo extends React.Component{
    constructor(porps) {
        super(porps);
        this.state={
            percentage: 0,
            textShow: true
        }
    }
    componentDidMount() {
        setTimeout(()=>{
            this.setState({
                textShow : false
            })
        },6000)
    }
    getEnter = (e) => {
        switch (e.index) {
            case 0:
                return {
                    rotate: 90,
                    opacity: 0,
                    y: -60,
                };
            case 10:
            case 1:
                return {
                    y: -60,
                    x: -10,
                    opacity: 0,
                };
            case 9:
            case 2:
                return {
                    y: -60,
                    x: 20,
                    opacity: 0,
                };
            case 3:
                return {
                    y: 60,
                    opacity: 0,
                };
            case 8:
            case 4:
                return {
                    x: 30,
                    opacity: 0,
                };
            case 5:
                return {
                    enter: [
                        {
                            scale: 2,
                            opacity: 0,
                            type: 'set',
                        },
                        { scale: 1.2, opacity: 1, duration: 300 },
                        { scale: 0.9, duration: 200 },
                        { scale: 1.05, duration: 150 },
                        { scale: 1, duration: 100 },
                    ],
                    leave: {
                        opacity: 0, scale: 0,
                    },
                };
            case 6:
                return {
                    scale: 0.8,
                    x: 30,
                    y: -10,
                    opacity: 0,
                };
            case 7:
                return {
                    scale: 0.8,
                    x: 30,
                    y: 10,
                    opacity: 0,
                };
            default:
                return {
                    opacity: 0,
                };
        }
    }

    render() {
        return (
                <div className='sticky-container'>
                    <div className="text-wrapper-video">
                    <Texty enter={this.getEnter} leave={this.getEnter}>{this.state.textShow && '每次展翼，飞向未来'}</Texty>
                    </div>
                    <div className="video-container video">
                        <video
                         x5-playsinline="true"
                         x5-video-player-type="h5"
                         playsinline="true" 
                         webkit-playsinline="true"
                         x-webkit-airplay="allow"
                        src="https://qiniu.metridynamic.com/video%2Fnew%20video%2F%E5%85%A8%E8%A6%81%E7%B4%A0%E4%B8%AD%E6%96%87.mp4" autoPlay loop muted>

                        </video>
                    </div>
                </div>
        )
    }
}
